<template lang="pug">
#user_change_plan_modal_wrapper
  b-modal#change-user-plan(title='プランを変更する', 'hide-footer')
    alert-error(v-if="error", :msg="error_msg")
    p {{$store.state.user.plan_to_change.display_name}}プランに変更します。よろしいでしょうか？
    p(v-if="isLowerPlan( $store.state.user.plan_to_change )").text-sm.invalid-feedback
      | ※次回契約更新日までの、変更前のプランの未利用期間分の料金は、変更後のプランの料金と相殺しております。
      br/
      | （プランをアップグレードいただいた場合、差額を追加でご請求し、プランをダウングレードいただいた場合、差額を次回のご請求時に減額いたします。）
    p(v-else).text-sm ※現在のプランの次回更新日までの料金は、変更後のプランの料金と相殺されますので、損することなくプラン変更が可能です。（プランをアップグレードいただいた場合、差額のみを今回追加でお支払いいただき、プランをダウングレードいただいた場合、差額を次回のお支払い時に減額いたします。）
    table.table.mt-3
      thead
        tr
          th(colspan=2) プラン詳細
      tbody
        tr
          th プラン名
          td {{$store.state.user.plan_to_change.display_name}}
        tr
          th 支払期間
          td {{pay_cycle($store.state.user.plan_to_change)}}
        tr
          th 料金
          td {{pay_amount($store.state.user.plan_to_change)}}
    .row(v-if="showCouponArea()")
      .col-md-12
        .form-group.text-sm
          label(for='coupon_code') クーポンコード
          .input-group
            input#coupon_code.form-control(type='text',
            v-model="coupon_code_form",
            name='coupon_code_form',
            placeholder='')
            span
              button.btn.btn-success.ml-2(@click="addCoupon") 適用
          span.text-xs.invalid-feedback(v-if="coupon_code_form")  ※クーポンはまだ適用されていません。
          div
            span.text-xs  ※過去に利用したクーポンを再度適用することはできません。
      .col-md-12.mb-4(v-if="$store.state.user.coupon_code")
        small.badge.badge-success {{ coupon_name }}
          button.btn.btn-tool.btn-tool(@click="removeCoupon")
            i.fas.fa-times.text-white

    .row
      .col-md-3.offset-md-3.col-sm-6.col-xs-6
        template(v-if="!submitting")
          button.btn.btn-success.btn-block(@click="changePlan") はい
        template(v-else)
          button.btn.btn-success.btn-block.disabled はい
      .col-md-3.col-sm-6.col-xs-6
        template(v-if="!submitting")
          button.btn.btn-default.btn-block(@click="cancel") いいえ
        template(v-else)
          button.btn.btn-default.btn-block.disabled いいえ
  b-modal#change-plan-success(title='プラン変更が完了しました','hide-footer')
    p ありがとうございました。
  b-modal#change-plan-success-and-warning(title='プラン変更が完了しました','hide-footer')
    template(v-if="isNewUi")
      p {{ newPlanName }}プランは、サイトリードを利用できるドメイン数が{{ newPlanLimit }}つに制限されます。
      p プラン変更に伴い、全てのドメインの利用およびサービスを停止しておりますので、利用を継続するドメインとサービスの再開をしてください。
      a(href="/users/tag_domains" style="color: white; background-color: #007bff;") 【利用再開はこちら】
    template(v-else)
      p ありがとうございました。
</template>

<script>
import Vue from 'vue'
import AlertError from '../parts/error.vue'

export default {
  data(){
    return {
      submitting: false,
      error: false,
      error_msg: "",
      coupon_code_form: "",
      coupon_name: "",
      new_plan_name: "",
      planData: {
        free: { name: 'Free', limit: 1 },
        basic: { name: 'Basic', limit: 1 },
        premium: { name: 'Premium', limit: 2 },
        master: { name: 'Master', limit: 2 },
        enterprise: { name: 'Enterprise', limit: 3 },
        '1m_pv': { name: '100万PV', limit: 3 },
        '2m_pv': { name: '200万PV', limit: 3 },
      },
      // 動的にプラン名とドメイン制限数を表示するための変数
      newPlanName: '',
      newPlanLimit: 0
    }
  },
  props: {
    is_new_ui: {
      type: Boolean,
      default: false
    }
  },
  components:{
    AlertError
  },
  computed: {
    isNewUi() {
      return this.is_new_ui
    }
  },
  methods: {
    async changePlan(){
      // this.submitting が true の場合は何もしない
      if(this.submitting) return
      this.submitting=true
      this.error=false
      let oldPlanName = this.$store.state.user.plan_name;
      let oldPlanLimit = this.planData[oldPlanName]?.limit || 0;
      try{
        await this.$store.dispatch("user/updateSubscription")
        let newPlanName = this.$store.state.user.plan_name;
        let newPlanKey = this.$store.state.user.plan_name;
        this.newPlanName = this.planData[newPlanKey]?.name || ''; // 新プラン名を取得
        this.newPlanLimit = this.planData[newPlanKey]?.limit || 0; // 新プランのドメイン制限数を取得
        let newPlanLimit = this.newPlanLimit;
        this.cancel()
        if (newPlanLimit < oldPlanLimit) {
          this.$bvModal.show('change-plan-success-and-warning')
        } else {
          this.$bvModal.show('change-plan-success')
        }
      } catch(e){
        this.error=true
        this.error_msg=e.message
      }
      this.submitting=false
    },
    cancel(){
      this.coupon_code_form = ''
      this.removeCoupon()
      this.$bvModal.hide('change-user-plan')
    },
    pay_cycle(plan){
      //console.log(plan)
      if(plan.interval == "month"){
        if(plan.interval_count == 1){
          return "月払い"
        } else if(plan.interval_count == 3) {
          return "3ヶ月ごと"
        } else if(plan.interval_count == 6) {
          return "6ヶ月ごと"
        } else if(plan.interval_count == 36) {
          return "3年ごと"
        } else {
          return plan.interval_count + "ヶ月ごと"
        }
      } else {
        return "年間払い"
      }
    },
    pay_amount(plan){
      if(plan.interval == "month"){
        if(plan.interval_count == 1){
          return "税込 " + plan.amount?.toLocaleString('ja-JP') + "円/月"
        } else if(plan.interval_count == 3) {
          return "税込 " + plan.amount?.toLocaleString('ja-JP') + "円（" + parseInt(plan.amount/3)?.toLocaleString('ja-JP') + "円 x 3ヶ月）"
        } else if(plan.interval_count == 6) {
          return "税込 " + plan.amount?.toLocaleString('ja-JP') + "円（" + parseInt(plan.amount/6)?.toLocaleString('ja-JP') + "円 x 6ヶ月）"
        } else if(plan.interval_count == 36) {
          return "税込 " + plan.amount?.toLocaleString('ja-JP') + "円（" + parseInt(plan.amount/36)?.toLocaleString('ja-JP') + "円 x 36ヶ月）"
        } else {
          return "税込 " + plan.amount?.toLocaleString('ja-JP') + "円（" + parseInt(plan.amount/plan.interval_count)?.toLocaleString('ja-JP') + "円 x " + plan.interval_count + "ヶ月）"
        }
      } else {
        return "税込 " + plan.amount?.toLocaleString('ja-JP') + "円（" + parseInt(plan.amount/12)?.toLocaleString('ja-JP') + "円 x 12ヶ月）"
      }
    },
    isLowerPlan(plan){
      return this.$store.getters["user/is_lower_plan"](plan)
    },
    showCouponArea(){
      // まだクーポンを使用していない かつ ダウングレードではない場合のみ表示
      return !this.isLowerPlan( this.$store.state.user.plan_to_change )
    },
    async addCoupon(){
      if (!this.coupon_code_form) return;
      const data = await this.$store.dispatch("user/checkCouponExists", this.coupon_code_form)
      if (data.error) {
        this.error=true
        this.error_msg=data.error
        this.coupon_code_form = ''
        return
      } else {
        this.error=false
        this.error_msg=''
        this.coupon_name = data['name']
        this.$store.commit("user/setCouponCode", this.coupon_code_form)
        this.coupon_code_form = ''
      }
    },
    removeCoupon(){
      this.coupon_name = ''
      this.$store.commit("user/setCouponCode", '')
    },
  },
  async mounted(){
    await Vue.nextTick()
  },
}
</script>
<style lang="scss" scoped>
</style>
